<template>
    <span>
        <el-form-item :label="$t.__('companysearch.FR_form.company_informations')" prop="search">
            <el-input
                :disabled="!providerEnabled"
                @keyup.enter.native="$emit('search-companies')"
                id="search"
                class="valign-middle"
                :class="{ 'w-5': inline }"
                v-model="form.search"
                :placeholder="$t.__('companysearch.FR_form.enter_company_informations')"
            />
        </el-form-item>
        <el-form-item v-if="useJobCode" :label="$t.__('common.labels.NAF_code')" prop="jobCode">
            <el-input
                :disabled="!providerEnabled"
                id="jobCode"
                v-model="form.jobCode"
                :placeholder="$t.__('companysearch.FR_form.enter_NAF_code')"
            ></el-input>
        </el-form-item>
        <el-form-item
            :label="$t.__('companysearch.FR_form.department')"
            prop="district"
            class="error-label-width-1"
        >
            <el-input
                :disabled="!providerEnabled"
                id="district"
                class="w-1 valign-middle"
                v-model="form.district"
                maxlength="3"
            />
        </el-form-item>
    </span>
</template>
<script>
export default {
    props: {
        providerEnabled: {
            type: Boolean,
            required: true,
            default: true,
        },
        form: {
            type: Object,
            required: true,
            default: () => {},
        },
        useJobCode: {
            type: Boolean,
            required: true,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>
